import { createThemeAssets, imageUrl } from '../createThemeAssets'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

export default {
    name: 'green',
    label: 'Green',
    assets,
    cssVars: {
        '--theme-root-bg': '#091f04',
        '--theme-page-bg': imageUrl(assets.home.pageBg),
        '--theme-page-bg-size': 'cover, cover, cover',
        '--theme-page-bg-position': 'center top, center top, center top',
        '--theme-header-bg': 'rgba(0, 0, 0, .3)',
        '--theme-header-control-bg': '#0a3200',
        '--theme-header-control-border': '#28af06',
        '--theme-header-control-border-gradient': 'linear-gradient(180deg, rgba(172, 216, 161, .45), rgba(40, 175, 6, 1))',
        '--theme-header-accent-bg': 'linear-gradient(180deg, #64f044 0%, #28cb00 100%)',
        '--theme-surface-bg': 'rgba(19, 71, 6, .4)',
        '--theme-surface-border': '#2a8c11',
        '--theme-soft-text': '#d2ffc7',
        '--theme-bright-text': '#fffafe',
        '--theme-input-bg': '#154f06',
        '--theme-input-border': '#42ce1f',
        '--theme-input-focus-bg': '#125c00',
        '--theme-input-focus-border': '#44f917',
        '--theme-input-focus-border-rgb': '224, 23, 249',
        '--theme-input-placeholder': 'rgba(210, 255, 199, .66)',
        '--theme-list-bg': 'rgba(0, 0, 0, .2)',
        '--theme-list-header-bg': 'rgba(23, 73, 10, .8)',
        '--theme-list-row-border': 'rgba(255, 255, 255, .22)',
        '--theme-active-bg': 'linear-gradient(90deg, #64f044 0%, #28cb00 100%)',
        '--theme-active-text': '#ffffff',
        '--theme-gold-bg': 'linear-gradient(180deg, #FFD426 0%, #FF7E13 100%)',
        '--theme-gold-text': '#290000',
        '--theme-banner-bg': imageUrl(assets.home.bannerBg),
        '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
        '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
        '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
        '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
        '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
        '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
        '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
        '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
        '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
        '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
        '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
        '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
        '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
        '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
        '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
        '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
        '--theme-home-classify-fixed-bg': 'linear-gradient(180deg, rgba(232, 255, 226, .04) 0%, rgba(232, 255, 226, 0) .16rem), linear-gradient(180deg, rgba(41, 89, 29, .98) 0%, rgba(22, 58, 13, .98) 100%)',
        '--theme-home-classify-item-bg': 'radial-gradient(circle at 12% 0, rgba(110, 224, 82, .2) 0, rgba(110, 224, 82, 0) 26%), linear-gradient(180deg, rgba(226, 255, 219, .1) 0%, rgba(226, 255, 219, 0) .1rem), linear-gradient(180deg, rgba(94, 160, 78, .96) 0%, rgba(59, 105, 47, .99) 100%)',
        '--theme-home-classify-icon-bg': '#3c7a2d',
        '--theme-home-classify-nav-bg': 'linear-gradient(180deg, rgba(226, 255, 219, .12) 0%, rgba(226, 255, 219, 0) .12rem), linear-gradient(180deg, rgba(93, 156, 77, .96) 0%, rgba(53, 99, 42, .99) 100%)',
        '--theme-home-classify-nav-border': 'rgba(226, 255, 219, .18)',
        '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(241, 255, 238, .08), 0 .04rem .1rem rgba(8, 24, 4, .16)',
        '--theme-home-banner-panel-bg': 'linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .02), rgba(28, 90, 13, .5))',
        '--theme-home-section-top-bg': 'linear-gradient(180deg, rgba(21, 82, 6, .6) 0%, rgba(21, 82, 6, 0) 100%)',
        '--theme-home-notice-line-bg': 'linear-gradient(180deg, #28cb00, #ecffe7, #28cb00)',
        '--theme-home-notice-item-bg': 'linear-gradient(-90deg, rgba(15, 53, 6, 0) 0%, rgba(15, 53, 6, .8) 100%)',
        '--theme-home-notice-icon-filter': 'brightness(0) saturate(100%) invert(78%) sepia(28%) saturate(1944%) hue-rotate(86deg) brightness(102%) contrast(101%) drop-shadow(0 .02rem .08rem rgba(172, 216, 161, .24))',
        '--theme-game-placeholder-surface': 'linear-gradient(180deg, rgba(86, 148, 70, .94) 0%, rgba(48, 90, 38, .99) 100%)',
        '--theme-game-placeholder-skeleton': 'linear-gradient(110deg, rgba(226, 255, 219, 0) 30%, rgba(110, 224, 82, .22) 50%, rgba(226, 255, 219, 0) 70%), linear-gradient(180deg, rgba(43, 91, 31, .48) 0%, rgba(10, 50, 0, .92) 100%)',
        '--theme-game-placeholder-fallback': 'radial-gradient(circle at 50% 18%, rgba(110, 224, 82, .18) 0%, rgba(110, 224, 82, 0) 36%), linear-gradient(180deg, rgba(43, 91, 31, .92) 0%, rgba(10, 50, 0, .99) 100%)',
        '--theme-game-placeholder-border': 'rgba(226, 255, 219, .14)',
        '--theme-game-title-bg': 'linear-gradient(180deg, rgba(48, 90, 38, .72) 0%, rgba(10, 50, 0, .9) 100%)',
        '--theme-game-title-text': '#d2ffc7',
        '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
        '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
        '--theme-footer-title-text': '#a9e799',
        '--theme-footer-body-text': '#e2fcdc',
        '--theme-footer-muted-text': 'rgba(217, 255, 208, .88)',
        '--theme-footer-copyright-text': '#ffffff',
        '--theme-footer-menu-title-bg': 'linear-gradient(90deg, rgba(23, 73, 10, .9) 0%, rgba(15, 53, 5, .08) 100%)',
        '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-footer-menu-list-bg': 'linear-gradient(90deg, rgba(14, 56, 4, .58) 0%, rgba(15, 53, 5, .12) 100%)',
        '--theme-footer-menu-link-text': '#e2fcdc',
        '--theme-home-banner-html-text': '#b4f6a4',
        '--theme-share-bg-top': imageUrl(assets.share.bgTop),
        '--theme-share-bg': imageUrl(assets.share.shareBg),
        '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
        '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
        '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
        '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
        '--theme-event-top-bg': imageUrl(assets.event.topBg),
        '--theme-event-top-right': imageUrl(assets.event.topRight),
        '--theme-event-detail-text': '#b4f6a4',
        '--theme-event-card-bg': 'var(--theme-popup-panel-bg)',
        '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
        '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
        '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
        '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
        '--theme-signin-accent-text': '#FF8400',
        '--theme-signin-accent-border': '#28cb00',
        '--theme-signin-progress-line': '#34aa17',
        '--theme-signin-disabled-btn-bg': '#587551',
        '--theme-signin-disabled-btn-text': '#ffffff',
        '--theme-signin-day-bg': '#267911',
        '--theme-signin-day-border': '#c1ffb1',
        '--theme-signin-unlocked-bg': 'linear-gradient(180deg, #65b052 0%, #68985c 99.29%)',
        '--theme-signin-secondary-amount-text': '#BF630E',
        '--theme-signin-nav-btn-bg': 'rgba(255, 255, 255, .2)',
        '--theme-signin-active-icon-shadow': '0px 2px 4px 0px rgba(205, 5, 5, .7)',
        '--theme-frame-line-vertical': 'linear-gradient(to bottom, transparent 0%, #367b25 10%, #28cb00 50%, #367b25 85%, transparent 100%)',
        '--theme-frame-line-horizontal': 'linear-gradient(to right, transparent 0%, #68ac57 15%, #28cb00 50%, #68ac57 85%, transparent 100%)',
        '--theme-tabbar-shell-bg': '#239008',
        '--theme-tabbar-text': 'rgba(255, 255, 255, .65)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-float-bg': 'linear-gradient(180deg, rgba(21, 79, 6, .96) 0%, rgba(57, 109, 44, .98) 100%)',
        '--theme-tabbar-divider': 'rgba(242, 255, 239, .18)',
        '--theme-tabbar-active-bg': [
            imageUrl(assets.tabbar.activeBorders[0]),
            imageUrl(assets.tabbar.activeBorders[1]),
            imageUrl(assets.tabbar.activeBorders[2]),
            imageUrl(assets.tabbar.activeBorders[3]),
            'linear-gradient(135deg, #28cb00, #28cb00)'
        ].join(','),
        '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
        '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
        '--theme-popup-bg': 'linear-gradient(180deg, #0d2f04 0%, #154f06 100%)',
        '--theme-popup-overlay-bg': 'rgba(4, 14, 32, .72)',
        '--theme-popup-close-bg': '#143e09',
        '--theme-popup-close-border': '#295b1c',
        '--theme-popup-panel-bg': 'rgba(19, 71, 6, .4)',
        '--theme-popup-panel-fill': '#1a560b',
        '--theme-popup-panel-border': 'linear-gradient(180deg, rgba(40, 129, 18, .6), rgba(41, 129, 19, .3))',
        '--theme-popup-panel-shadow': 'inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .2), inset -.16rem -.16rem .58rem 0 rgba(255, 255, 255, .2)',
        '--theme-panel-strong-bg': 'linear-gradient(180deg, #2e8618 0%, #2c9213 100%)',
        '--theme-card-strong-bg': 'linear-gradient(180deg, #2f6322 0%, #102f08 100%)',
        '--theme-card-strong-border': '#298f10',
        '--theme-popup-tabs-bg': 'rgba(34, 94, 19, .8)',
        '--theme-popup-mask-bg': 'rgba(15, 53, 5, .5)',
        '--theme-popup-box-bg': 'rgba(21, 79, 6, .9)',
        '--theme-popup-box-border': '#22ac00',
        '--theme-popup-box-shadow': 'inset 0 0 .1rem 0 rgba(64, 249, 18, .8)',
        '--theme-popup-amount-text': '#FFCE2D',
        '--theme-sidebar-bg': `${imageUrl(assets.sidebar.sidebarBorder)}, radial-gradient(70.71% 70.71% at 0% 50%, #114105 0%, #0a3200 100%)`,
        '--theme-sidebar-bg-size': '12px auto, 100% 100%',
        '--theme-sidebar-border': '#204916',
        '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
        '--theme-sidebar-item-text': '#a9e799',
        '--theme-sidebar-item-active-bg': 'linear-gradient(-90deg, rgba(15, 61, 5, 0) 0%, #28cb00 100%)',
        '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #28cb00, #dfffd8, #28cb00)',
        '--theme-sidebar-control-bg': '#174f09',
        '--theme-sidebar-control-border': '#2e731d',
        '--theme-sidebar-service-bg': 'linear-gradient(180deg, #64f044 0%, #0f5a00 100%)',
        '--theme-sidebar-drawer-mask-bg': 'rgba(54, 108, 40, .58)'
    }
}
